export const SDK_VERSION = '7.119.2';
